import { useState } from 'react'

import { Card, Icon, typography } from '@joor/design-system'
import styled from 'styled-components'

import { OrderData } from '../../Overview'
import { Box } from './LegalWidget.ui'
import { getFormattedText } from './LegalWidget.utils'
import { LoadingLegalWidget } from './LoadingLegalWidget'
import { LegalModal } from 'features/Orders/Review/modals/LegalModal/LegalModal'

export enum LegalWidgetTestIds {
  TermsPreview = 'TermsPreview',
}

const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 32px;
  padding: 8px;

  background: var(--color-neutral-000-full);
  ${typography.alpha.primaryActive.body3}
`

const TermsPreview = styled.div`
  height: 113px;
  margin: 16px 16px 1px 16px;
  overflow: hidden;

  background: var(--color-neutral-000-full);
  border-radius: 3px 3px 0px 0px;
`

const PreviewTitle = styled.div`
  padding: 8px;
  ${typography.alpha.primaryActive.headline2}
  font-size: calc(var(--size-font-large) * 0.6);
`

const PreviewContent = styled.div`
  padding: 4px 16px;
  ${typography.alpha.primaryActive.body1}
  font-size: calc(var(--size-font-base) * 0.6);
  line-height: 16px;
  letter-spacing: 1;
  max-width: 291px;
`

type Props = {
  className?: string
  testId?: string
  termsAndConditions: OrderData['termsAndConditions']
  retailerProfile: OrderData['retailerProfile']
  brandName: OrderData['brand']['name']
  loading?: boolean
}

export const LegalWidget = ({
  className = '',
  testId,
  termsAndConditions,
  retailerProfile,
  brandName,
  loading = false,
}: Props) => {
  const [isLegalModalOpen, setLegalModalOpen] = useState(false)

  const formattedTerms = termsAndConditions?.terms
    ? getFormattedText(termsAndConditions?.terms)
    : []

  return (
    <Card className={className} testId={testId} title="Legal">
      {loading ? (
        <LoadingLegalWidget fieldsAmount={1} />
      ) : (
        <>
          <Box onClick={() => setLegalModalOpen(true)}>
            <TermsPreview data-testid={LegalWidgetTestIds.TermsPreview}>
              <PreviewTitle>Terms & Conditions</PreviewTitle>
              <PreviewContent>{formattedTerms}</PreviewContent>
            </TermsPreview>
            <CheckboxWrapper>
              <Icon
                iconSize="small"
                type={
                  termsAndConditions?.agreesWithTerms ? 'semantic' : 'default'
                }
                iconName={
                  termsAndConditions?.agreesWithTerms
                    ? 'success'
                    : 'check-circle-on'
                }
                variant={
                  termsAndConditions?.agreesWithTerms ? 'DEFAULT' : 'INACTIVE'
                }
              />
              &nbsp;Terms & Conditions
            </CheckboxWrapper>
          </Box>
          <LegalModal
            isOpen={isLegalModalOpen}
            setOpen={setLegalModalOpen}
            terms={formattedTerms}
            agreesWithTerms={Boolean(termsAndConditions?.agreesWithTerms)}
            termsCompany={retailerProfile?.displayName || ''}
            brandName={brandName}
            termsName={termsAndConditions?.name}
            termsTitle={termsAndConditions?.title}
            agreedPlatform={termsAndConditions?.platform}
            agreedOn={termsAndConditions?.dateModified}
          />
        </>
      )}
    </Card>
  )
}
